<template>
   <div>
     <div v-if="(items!==null&&items.length>0)||mode==='nomessage'">
       <select v-model="optZeroSelected" v-if="displayType==='0'">
         <option v-for="option in items" v-bind:value="option.value">
           {{ option.text }}
         </option>
       </select>
       <select  v-if="displayType==='1'" multiple="true" v-bind:size="displaySize">
         <option v-for="option in items" v-bind:value="option.value">
           {{ option.text }}
         </option>
       </select>
       <div v-if="displayType==='2'&&filterLength>0" class="fRow">
         <div class="fCol mr-3" v-for="n in filterLength">
           <p v-for="option in filteredItems(n)">
             <input type="checkbox" @change="changeSelected(option.value)" :checked="optTwoSelected.indexOf(option.value)>-1" />&nbsp;&nbsp;{{option.text}}
           </p>
         </div>
         <div class="clearfix"></div>
       </div>
     </div>
     <div v-if="items===null||items.length===0">
         There are no items to select
     </div>
   </div>
</template>

<style scoped>
  .fRow {
    display: flex;
    flex-direction: row;
  }
  .fCol {
    flex-grow:1;
  }
</style>

<script>
  export default {
     name: 'GenericList',
     props: [
        "items",
        "mode",
        "displayType",
        "displaySize",
        "preSelected"
     ],
     data() {
       return {
         filterLength:0,
         optZeroSelected:null,
         optTwoSelected:[]
       }
     },
     methods: {
        changeSelected(id) {
         var i =this.optTwoSelected.indexOf(id);
         if (i===-1) {
           this.optTwoSelected.push(id);
         }
         else {
           this.optTwoSelected.splice(i,1);
         }
       },
       filteredItems: function (n) {
         return this.items.slice((n-1)*15, (n-1)*15+15)
       },
       getResult() {
         if (this.displayType==='0') {
           return this.optZeroSelected;
         }
         else if (this.displayType==='2') {
           return this.optTwoSelected;
         }
       }
     },
     mounted() {
       if (this.displayType==='0') {
         this.items.unshift({
           text:"--- Select ---",
           value:null
         })
       }
       else if (this.displayType==='2') {
         if (this.items.length>=15) {
           if (this.items.length%15>0) {
             this.filterLength = (this.items.length-(this.items.length%15))/15+1;
           }
           else {
             this.filterLength = this.items.length/15;
           }
    
         }
         else if (this.items.length>0) {
           this.filterLength=1;
         }

         if (typeof(this.preSelected)!=="undefined" && this.preSelected!==null) {
           this.optTwoSelected=this.preSelected;
         }
       }
     }
  }
</script>
